import React, { useState } from 'react';
import { useCRM } from '../utils/CRMContext';
import AppHeader from '../components/ui/AppHeader';
import DealPipeline from '../components/deals/DealPipeline';
import PipelineManager from '../components/deals/PipelineManager';
import LoadingScreen from '../components/ui/LoadingScreen';
import './MapDashboard.css';

/** Deal pipeline view — leads list moved to `/leads` (LeadsHub). */
const MapDashboard: React.FC = () => {
  const { loading } = useCRM();
  const [showPipelineManager, setShowPipelineManager] = useState(false);

  if (loading) {
    return <LoadingScreen size="large" />;
  }

  return (
    <div className="map-dashboard-container">
      <AppHeader />

      <div className="map-dashboard-body">
        <main className="map-dashboard-main">
          <div className="pipeline-view-container">
            <DealPipeline />
          </div>
        </main>
      </div>

      {showPipelineManager && (
        <div className="pipeline-manager-overlay">
          <PipelineManager onClose={() => setShowPipelineManager(false)} />
        </div>
      )}
    </div>
  );
};

export default MapDashboard;
